import { render } from "./DownloadButtons.vue?vue&type=template&id=85158cfe"
import script from "./DownloadButtons.vue?vue&type=script&lang=js"
export * from "./DownloadButtons.vue?vue&type=script&lang=js"

import "./DownloadButtons.vue?vue&type=style&index=0&id=85158cfe&lang=css"

import exportComponent from "/var/www/localhrm.apcwo.org/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__